import React, { useState } from "react";
import AdvanceCustomChartDisplay from "./AdvanceCustomChartDisplay";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import AdvanceCustomChartDisplayEditMode from "./AdvanceCustomChartDisplayEditMode";
import AdvanceCustomChartHeader from "./AdvanceCustomChartHeader";

const AdvanceCustomChart = (props) => {
    const { advanceWidgetDashboardDataLoading, expand, isMetricsExpanded } = props;
    // const advCustomChartReducer = useSelector((state) => state.advCustomChartReducer);
    const showAdvanceEditor = useSelector((state) => state.dashboardReducer.showAdvanceEditor);
    const [canRender, setCanRender] = useState(true);

    useEffect(() => {
        const call = async () => {
            if (canRender) {
                await setCanRender(false);
                setTimeout(() => {
                    setCanRender(true);
                }, 10);
            }
        };
        call();
    }, [expand, isMetricsExpanded]);
    let nodata = props.data?.nodata || props?.data?.data?.length === 0 || false;
    if (typeof props.data === "object" && Object.keys(props.data)?.length === 0) {
        nodata = true;
    }

    return (
        <>
            {!showAdvanceEditor ? (
                <>
                    <AdvanceCustomChartHeader
                        {...props}
                        // advCustomChartReducer={advCustomChartReducer}
                        widgetContainerRef={props.widgetContainerRef}
                        data={props?.data?.data}
                        nodata={nodata}
                        csvData={props.data}
                        advanceWidgetDashboardDataLoading={advanceWidgetDashboardDataLoading}
                    />
                    {/* <AdvanceCustomChartDisplay
                        data={props.data}
                        advCustomChartReducer={advCustomChartReducer}
                        widgetContainerRef={props.widgetContainerRef}
                        widget={props.widget?.widget_filter?.extraArgs}
                    /> */}
                </>
            ) : !advanceWidgetDashboardDataLoading && canRender ? (
                <AdvanceCustomChartDisplayEditMode
                    noTopicsSelected={props.noTopicsSelected}
                    data={props?.data?.data}
                    maximizeData={props.data?.maximizeData || props.data?.minimizedData} // for 2D 1M minimized data is used for 9+1 formation
                    nodata={nodata}
                    widgetContainerRef={props.widgetContainerRef}

                    // advCustomChartReducer={advCustomChartReducer}
                />
            ) : (
                <Dimmer inverted active>
                    <Loader size="big skiptranslate">Loading data</Loader>
                </Dimmer>
            )}
        </>
    );
};
export default React.memo(AdvanceCustomChart);
